<template>
    <v-card elevation="0" class="justify-center mt-2">
        <v-row no-gutters class="pb-1">
            <v-col md="12" cols="12" class="">
                <v-card elevation="0" class="px-4">
                    <v-row>
                        <v-col md="12" cols="6" class="my-1">
                            <h4 class="font-weight-light primary--text">
                                Datos Básicos
                            </h4>
                        </v-col>
                    </v-row>
                    <!-- <v-divider></v-divider> -->
                    <v-row class="mb-n7">
                        <v-col md="4" cols="12">
                            <v-text-field
                                dense
                                v-model="Name"
                                label="Nombre"
                                style="padding: 28px 0px 17px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col md="3" cols="12">
                            <v-select
                                clearable
                                chips
                                :items="opciones.tarifas.operator"
                                item-text="human"
                                item-value="encoded"
                                v-model="Operator"
                                :label="Operator ? Operator : 'Operador'"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="primary" class="white--text">
                                        <v-icon> mdi-signal-variant </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col md="2" cols="12">
                            <v-select
                                clearable
                                hide-selected
                                chips
                                :items="opciones.tarifas.segment"
                                item-text="human"
                                item-value="encoded"
                                v-model="segment"
                                label="Segmento"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        color="yellow darken-2"
                                        class="white--text"
                                    >
                                        <v-icon> mdi-call-merge </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col md="2" cols="6">
                            <v-text-field
                                :disabled="formType != 'add'"
                                v-model="Price"
                                label="Precio"
                                required
                                style="padding: 21.1px 0px 12px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col md="1" style="padding: 21px 10px 0px 10px">
                            <v-select
                                hide-selected
                                :items="['€']"
                                label="PVP"
                                value="€"
                                disabled
                            ></v-select>
                        </v-col>
                        <!-- <v-col md="1">
                                                <v-text-field
                                                    v-model="MaxNumber"
                                                    label="Max"
                                                    required
                                                    style="
                                                        padding: 21.1px 0px 12px
                                                            0px;
                                                    "
                                                ></v-text-field>
                                            </v-col> -->
                    </v-row>
                </v-card>
            </v-col>
            <!-- <v-col md="4" cols="12">
                                    <v-card elevation="0" class="px-4">
                                        <v-row>
                                            <v-col md="6" class="mt-1">
                                                <h4
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Voz
                                                </h4>
                                            </v-col>
                                            <v-col
                                                md="6"
                                                class="mb-1 mt-1"
                                            >
                                                <h4
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Internet
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                        <v-row class="mb-n7">
                                            <v-col md="3" cols="6">
                                                <v-text-field
                                                    v-model="Voice"
                                                    label="Minutos"
                                                    required
                                                    style="
                                                        padding: 21.1px 0px 12px
                                                            0px;
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                md="3"
                                                cols="6"
                                                style="
                                                    padding: 21px 10px 0px 10px;
                                                "
                                            >
                                                <v-select
                                                    hide-selected
                                                    :items="['Minutes']"
                                                    label="min"
                                                    disabled
                                                ></v-select>
                                            </v-col>
                                            <v-col md="3">
                                                <v-text-field
                                                    v-model="Mobile_Line_Data"
                                                    label="Valor"
                                                    required
                                                    style="
                                                        padding: 21.1px 0px 12px
                                                            0px;
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                md="3"
                                                style="
                                                    padding: 21px 10px 0px 10px;
                                                "
                                            >
                                                <v-select
                                                    hide-selected
                                                    :items="['MB', 'GB']"
                                                    label="Unidad"
                                                    v-model="Data_Unit"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col> -->
        </v-row>
        <v-row class="justify-center mt-2" no-gutters>
            <v-col md="12">
                <v-card elevation="0" class="py-1 px-4">
                    <v-row>
                        <v-col md="12" class="mb-1 mt-1">
                            <h4 class="font-weight-light primary--text">
                                Extras
                            </h4>
                        </v-col>
                    </v-row>
                    <!-- <v-divider></v-divider> -->
                    <v-row class="mb-n7">
                        <v-col cols="12">
                            <v-autocomplete
                                clearable
                                multiple
                                chips
                                :items="filteredPromotions"
                                item-text="name"
                                item-value="id"
                                v-model="SelectedPromotions"
                                label="Promociones"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        @click:close="removePromo(item)"
                                        close
                                        color="pink"
                                        class="white--text"
                                    >
                                        <v-icon> mdi-credit-card </v-icon>
                                        {{ item.name ? item.name : item.id }}
                                    </v-chip>
                                </template>
                                <template #item="{ item }">
                                    <v-row>
                                        <v-col cols="11">
                                            {{
                                                item && item.name
                                                    ? item.name
                                                    : item.id
                                            }}
                                        </v-col>
                                        <v-col cols="1">
                                            <v-icon
                                                :color="
                                                    item.is_active
                                                        ? 'green'
                                                        : 'red'
                                                "
                                            >
                                                mdi-circle
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <!-- <v-col v-if="autoUpfront" cols="3" class="pl-1">
                                    <v-card class="px-4 pb-1" text>
                                        <v-row>
                                            <v-col md="12" class="mb-1 mt-1">
                                                <h4
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Upfront
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                        <v-row class="mb-n7 mt-n2">
                                            <v-col md="9">
                                                <v-text-field
                                                    v-model="Upfront"
                                                    label="Cantidad"
                                                    required
                                                    style="
                                                        padding: 21.1px 0px 12px
                                                            0px;
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                md="3"
                                                style="
                                                    padding: 21px 10px 0px 10px;
                                                "
                                            >
                                                <v-select
                                                    hide-selected
                                                    :items="['€']"
                                                    label="Unidad"
                                                    value="€"
                                                    disabled
                                                >
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col> -->
        </v-row>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AdditionalManagementForm',
    data: () => ({
        PriceUnit: '€',
        autoUpfront: true,
    }),
    methods: {
        removePromo(item) {
            let index = this.SelectedPromotions.indexOf(item.id);
            this.SelectedPromotions.splice(index, 1);
        },
        clearFields() {
            this.$store.state.ManagementBase.additionalManagement.Name = '';
            this.$store.state.ManagementBase.additionalManagement.Operator = '';
            this.$store.state.ManagementBase.additionalManagement.IsActive = false;
            this.$store.state.ManagementBase.additionalManagement.Mobile_Line_Data =
                '';
            this.$store.state.ManagementBase.additionalManagement.Data_Unit =
                '';
            this.$store.state.ManagementBase.additionalManagement.Voice = '';
            this.$store.state.ManagementBase.additionalManagement.Voice_Unit =
                '';
            this.$store.state.ManagementBase.additionalManagement.Price = '';
            this.$store.state.ManagementBase.additionalManagement.MaxNumber = 0;
            this.$store.state.ManagementBase.additionalManagement.Upfront =
                null;
            this.$store.state.ManagementBase.additionalManagement.segment = '';
            this.$store.state.ManagementBase.additionalManagement.SelectedPromotions =
                [];
        },
        closeForm() {
            this.$store.commit(
                'ManagementBase/additionalManagement/isOpenDialog',
                false
            );
            this.clearFields();
        },
        submitAdditional() {
            if (
                this.$store.state.ManagementBase.additionalManagement
                    .formType == 'add'
            )
                this.$store.dispatch(
                    'ManagementBase/additionalManagement/addAdditional'
                );
            else
                this.$store.dispatch(
                    'ManagementBase/additionalManagement/editAdditional'
                );

            this.closeForm();
        },
    },
    computed: {
        filteredPromotions() {
            let filterIs_active = (item) => (item.is_active = true);
            let filterOperator = (item) =>
                this.operator ? item.operator == this.operator : true;

            return this.promotions.filter(
                (item) => filterIs_active(item) && filterOperator(item)
            );
        },
        isOpenDialog: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .isOpenDialog;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/isOpenDialog',
                    val
                );
                this.clearFields();
            },
        },
        Name: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .Name;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/Name',
                    val
                );
            },
        },
        Operator: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .Operator;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/Operator',
                    val
                );
            },
        },
        IsActive: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/IsActive',
                    val
                );
            },
        },
        isEditableForm() {
            return this.formType == 'edit' || this.formType == 'watch';
        },
        Mobile_Line_Data: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .Mobile_Line_Data;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/Mobile_Line_Data',
                    val
                );
            },
        },
        Data_Unit: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .Data_Unit;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/Data_Unit',
                    val
                );
            },
        },
        Voice: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .Voice;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/Voice',
                    val
                );
            },
        },
        MaxNumber: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .MaxNumber;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/MaxNumber',
                    val
                );
            },
        },
        segment: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .segment;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/segment',
                    val
                );
            },
        },
        SelectedPromotions: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement.SelectedPromotions.map(
                    (promotion) => promotion.id
                );
            },
            set(discountIds) {
                this.$store.state.ManagementBase.additionalManagement.SelectedPromotions =
                    [];

                discountIds.forEach((discountId) => {
                    this.$store.state.ManagementBase.additionalManagement.SelectedPromotions.push(
                        this.promotions.find(
                            (promotion) => promotion.id == discountId
                        )
                    );
                });
            },
        },
        Price: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .Price;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/Price',
                    val
                );
            },
        },
        Upfront: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .Upfront;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/Upfront',
                    val
                );
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        ...mapState('ManagementBase', {
            formType: (state) => state.baseForm.formType,
        }),
        ...mapState('ManagementBase/promotionManagement', {
            promotions: (state) => state.promotionManagement.promotions,
        }),
    },
};
</script>
